import { use } from "react";
import { useState, useRef, useEffect, memo } from "react";
import DisplayOdd from "./DisplayOdd";
import { isMobile } from "react-device-detect";
import moment from "moment";
const HrGrMatchOdd = ({
  onChildRuleShow,
  eventDetails,
  matchOdds,
  setBetSlipDetails,
  HRGRBook
}) => {
  const [timeLeft, setTimeLeft] = useState("");
  const [timeLeftInHour, setTimeLeftInHour] = useState("");

  let betfair_runners = eventDetails.betfair_runners;
  let gameType = "";

  gameType = eventDetails?.game_type;

  function displayTime(evt_od) {
    evt_od = new Date(evt_od);
    let mongoTime = evt_od;
    let eventDate = moment(Number(mongoTime)).local().format("hh:mm A");
    return eventDate;
  }

  //console.log("eventDetails->", eventDetails);

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  const ShowBook = (section_id) => {
    if (!HRGRBook || !HRGRBook.length) {
      return "";
    }
    for (let i = 0; i < HRGRBook.length; i++) {
      const obj = HRGRBook[i];
      if (String(obj.runner_sid) === String(section_id)) {
        if (
          obj.amount === undefined ||
          obj.amount === null ||
          obj.amount === ""
        ) {
          return "";
        }
        return Math.round(Number(obj.amount) * -1);
      }
    }
    return "";
  };

  const timeRemaining = (eventDate) => {
    //useEffect(() => {

    const interval = setInterval(() => {
      const startDate = moment(); // current time
      const endDate = moment(eventDate); // your target date

      const duration = moment.duration(endDate.diff(startDate));

      const days = Math.floor(duration.asDays());
      const hours = duration.hours();
      const minutes = duration.minutes();
      const seconds = duration.seconds();
      if (minutes < 0) {
        const startDate = moment(eventDate); // your target date
        const endDate = moment(); // current time
        const duration = moment.duration(endDate.diff(startDate));
        const days = Math.floor(duration.asDays());
        const hours = duration.hours();
        const minutes = duration.minutes();
        const seconds = duration.seconds();
        setTimeLeft(`${"Elapsed"}: ${hours}:${minutes}:${seconds}`);
        setTimeLeftInHour(`${"in"} ${hours} ${"hours"}`);
      } else {
        setTimeLeft(`${"Remaining"}: ${hours}:${minutes}:${seconds}`);
        setTimeLeftInHour(`${"in"} ${hours} ${"hours ago"}`);
      }
    }, 1000);

    return () => clearInterval(interval); // cleanup on unmount
    // }, []);
  };

  function GetImageName(runnerData) {
    //https://bp-silks.lhre.net/proxy/fa735c3d-4006-787b-b446-4874905d99ee.png
    let link = `${runnerData.colours_filename_url}`;

    if (eventDetails.countryCode.toLowerCase() == "au") {
      //link = `https://bp-silks.lhre.net/saddle/au/${runnerData.sort_priority}.svg`;
    } else if (eventDetails.countryCode.toLowerCase() == "gb") {
      //link = `https://bp-silks.lhre.net/saddle/uk/${runnerData.sort_priority}.svg`;
    }

    return link;
  }

  useEffect(() => {
    timeRemaining(eventDetails.evt_od);
  }, []); // Empty dependency array

  function getCurrentStatus(matchOdds, eventDetails, runnerData) {
    let returnObj = {};
    returnObj.status = true;
    returnObj.displayTxt = "";

    if (
      matchOdds !== null &&
      matchOdds !== undefined &&
      matchOdds[runnerData?.section_id]?.event_status == "OPEN"
    ) {
    } else {
      if (
        matchOdds !== null &&
        matchOdds !== undefined &&
        matchOdds[runnerData?.section_id]?.event_status != "OPEN"
      ) {
        returnObj.status = false;
        returnObj.displayTxt = matchOdds[runnerData?.section_id]?.event_status;
      }
    }

    return returnObj;
  }

  return (
    <div>
      <style>
        {`.runner-name {
                    padding-top: 5px;
                }
                .runner-name img {
                    width: 28px;
                }
                `}
      </style>
      <div
        class="content panel-group col-md-12"
        style={{ paddingLeft: "0px", paddingRight: "0px" }}
      >
        <div class="card card-accent-primary">
          <div class="card-header">
            <h4>
              <strong
                className="site_family"
                style={{ fontSize: isMobile ? "1.1rem" : "" }}
              >
                {displayTime(eventDetails.evt_od)} {eventDetails.evt_evt}
                {" - "}
                {eventDetails.matchSummaryText4}
              </strong>{" "}
              <span style={{ color: "rgb(232, 62, 140)" }}>
                <strong className="site_family">
                  {eventDetails.evt_status}
                </strong>
              </span>{" "}
              <a
                className="cursor-pointer"
                onClick={() => {
                  const width = 1200;
                  const height = 560;
                  const left = window.screenX + (window.outerWidth - width) / 2;
                  const top =
                    window.screenY + (window.outerHeight - height) / 2;

                  window.open(
                    `/agent/hr-gr-user-book/${eventDetails.cat_mid}`,
                    "HrGrUserBookWindow",
                    `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`
                  );
                }}
              >
                <i className="fa fa-address-book"></i>
              </a>
            </h4>
          </div>{" "}
          <div
            class="card-body market-box MBoxNopadding"
            style={{ padding: isMobile ? "0px" : "" }}
          >
            {" "}
            <div class="row bg-gray-100 market-head">
              <div class="col">
                <strong className="site_family">
                  {moment(eventDetails.evt_od)
                    .tz("Asia/Kolkata")
                    .format("DD MMM HH:mm")}
                </strong>
              </div>{" "}
              <div class="col text-right">
                <strong className="site_family">{timeLeft}</strong>
              </div>
            </div>{" "}
            {betfair_runners !== null &&
              betfair_runners !== undefined &&
              betfair_runners !== "" &&
              betfair_runners.length > 0 &&
              betfair_runners.map((runnerData) => {
                const bookValue = ShowBook(runnerData.section_id);
                return (
                  <div
                    class="row runners"
                    key={runnerData.section_id}
                    style={{
                      backgroundColor:
                        matchOdds &&
                        matchOdds[runnerData.section_id]?.is_winner === 1
                          ? "#b7f777"
                          : ""
                    }}
                  >
                    <div
                      class="col-7 col-md-4 runner-name"
                      style={{ paddingTop: "0px" }}
                    >
                      <img
                        src={GetImageName(runnerData)}
                        style={{ display: gameType == 4 ? "" : "none" }}
                      />{" "}
                      <span
                        style={{
                          display: "inline-block",
                          verticalAlign: "middle"
                        }}
                      >
                        <strong
                          className="site_family"
                          style={{ fontSize: "1rem", paddingLeft: "5px" }}
                        >
                          {runnerData.runner_name}
                        </strong>
                        <div
                          className="position-plus site_family"
                          style={{
                            color: bookValue >= 0 ? "green" : "red",
                            display: bookValue === "" ? "none" : "block",
                            fontWeight: "bold"
                          }}
                        >
                          {bookValue === "" ? "" : formatTruncate(bookValue)}
                        </div>
                      </span>
                    </div>{" "}
                    <div class="col-5 col-md-8 price">
                      <div class="row">
                        <div class="col-md-2 d-none d-md-block cta-back site_family">
                          {matchOdds && (
                            <DisplayOdd
                              odd={matchOdds[runnerData.section_id]?.r1b3}
                              rate={matchOdds[runnerData.section_id]?.rate3}
                              oddtype="b1"
                            />
                          )}
                        </div>{" "}
                        <div class="col-md-2 d-none d-md-block cta-back site_family">
                          {matchOdds && (
                            <DisplayOdd
                              odd={matchOdds[runnerData.section_id]?.r1b2}
                              rate={matchOdds[runnerData.section_id]?.rate2}
                              oddtype="b2"
                            />
                          )}
                        </div>{" "}
                        <div class="col-6 col-md-2 cta-back site_family">
                          {matchOdds && (
                            <DisplayOdd
                              odd={matchOdds[runnerData.section_id]?.r1b}
                              rate={matchOdds[runnerData.section_id]?.rate1}
                              oddtype="b"
                            />
                          )}
                        </div>{" "}
                        <div class="col-6 col-md-2 cta-lay site_family">
                          {matchOdds && (
                            <DisplayOdd
                              odd={matchOdds[runnerData.section_id]?.r1l}
                              rate={matchOdds[runnerData.section_id]?.rate4}
                              oddtype="l"
                            />
                          )}
                        </div>{" "}
                        <div class="col-md-2 d-none d-md-block cta-lay site_family">
                          {matchOdds && (
                            <DisplayOdd
                              odd={matchOdds[runnerData.section_id]?.r1l2}
                              rate={matchOdds[runnerData.section_id]?.rate5}
                              oddtype="l1"
                            />
                          )}
                        </div>{" "}
                        <div class="col-md-2 d-none d-md-block cta-lay site_family">
                          {matchOdds && (
                            <DisplayOdd
                              odd={matchOdds[runnerData.section_id]?.r1l3}
                              rate={matchOdds[runnerData.section_id]?.rate6}
                              oddtype="l2"
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    <div
                      class="row "
                      style={{
                        lineHeight: "45px",
                        color: "red",
                        textAlign: "center",
                        background: "rgb(236, 236, 237)",
                        textTransform: "uppercase",
                        display:
                          matchOdds &&
                          matchOdds[runnerData.section_id]?.section_status ===
                            "ACTIVE"
                            ? "none"
                            : "block"
                      }}
                    >
                      <div
                        style={{ width: "100%", textAlign: "center" }}
                        class="site_family"
                      >
                        {matchOdds &&
                          matchOdds[runnerData.section_id]?.section_status}
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>{" "}
        </div>{" "}
      </div>
    </div>
  );
};

export default HrGrMatchOdd;
